/**
 * Single source of truth for brand tokens. Anything visual or copy-driven
 * that might change on a rebrand lives here — components and stylesheets
 * read from this file (directly, or through CSS variables it emits).
 */
export const brand = {
  name: "Manteca Book Besties",
  shortName: "Book Besties",
  tagline: "Read together, stay besties.",
  established: 2026,
  membershipPriceLabel: "$5/month",

  colors: {
    blush: "#F3CAD6", // primary, the pink stucco wall
    aqua: "#22B0A6", // secondary accent, the pool
    coral: "#E86F4E", // highlights and headlines, the sunset
    brass: "#C99A3F", // metallic detail, rules
    palm: "#123F38", // dark anchor and text, deep teal-green
    sand: "#FBF2E6", // page background, the paper
    ink: "#2A2018", // body text
  },

  fonts: {
    display: "Fraunces", // black + black italic, lowercase, set tight
    body: "Inter",
    label: "Archivo", // uppercase, wide letter-spacing
  },

  /** Google Fonts URL — load once in the document head. */
  fontsHref:
    "https://fonts.googleapis.com/css2?family=Archivo:wght@500;600;700&family=Fraunces:ital,opsz,wght@0,9..144,900;1,9..144,900&family=Inter:wght@400;500;600;700&display=swap",
} as const;

export type Brand = typeof brand;
export type BrandColor = keyof Brand["colors"];
